import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function MyStorySection() {
  return <section id="historia" className="py-24 bg-white relative overflow-hidden" data-id="element-121" data-mp="1v0zfu18pncoa">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-beige/20 rounded-l-full blur-3xl -z-10" data-id="element-122" data-mp="2910d76pro1z0" />

      <div className="container mx-auto px-6 md:px-12" data-id="element-123" data-mp="242gt7buqh09a">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-124" data-mp="2iwtsuyys8bl0">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-125" data-mp="2dzbqjrf9sulz">
            <div className="absolute inset-0 bg-brand-gold/15 blur-2xl rounded-full transform scale-110 animate-pulse-glow" data-id="element-126" data-mp="2wq2vmgs85yuk" />
            <div className="aspect-[4/5] rounded-2xl bg-brand-beige/30 overflow-hidden relative soft-glow" data-id="element-127" data-mp="241lxnbk8kje7">
              <img src="https://cdn.magicpatterns.com/uploads/occDScoDdqr7UZoTVWFm2q/ChatGPT_Image_21_jul_2026,_04_46_44_p.m..png" alt="Mi experiencia con el acné hormonal - collage de fotos mostrando mi piel" className="w-full h-full object-cover" data-id="element-128" data-mp="28zdzaxaonjvl" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-cream rounded-full -z-10 animate-float" data-id="element-129" data-mp="2rwygdi77he5n" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-brand-sage-light/30 rounded-full -z-10 animate-float" style={{
            animationDelay: '2s'
          }} data-id="element-130" data-mp="2wp8alafct0dq" />
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-131" data-mp="3apj2mgsegl0h">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-6" data-id="element-132" data-mp="1fkt6hry92t8y">
              Mi Historia...
            </h2>

            <div className="space-y-6 text-brand-charcoal/80 font-light leading-relaxed" data-id="element-133" data-mp="1u8waivsqfuv4">
              <p data-id="element-134" data-mp="1pa30xegkgo08">
                Durante años luché contra el acné hormonal. Gasté miles de pesos
                en tratamientos agresivos, rutinas confusas y productos que
                prometían milagros pero solo dejaban mi piel más sensible e
                irritada.
              </p>
              <p data-id="element-135" data-mp="8xxljgp2yogj">
                La frustración era constante. Me miraba al espejo y sentía que
                mi piel nunca iba a sanar. Hasta que descubrí el K-Beauty y,
                específicamente, la línea RIMAN.
              </p>
              <p data-id="element-136" data-mp="2fn7ys1o2ct94">
                Cambiar a una rutina minimalista, enfocada en reparar la barrera
                de mi piel con ingredientes suaves y efectivos, lo cambió todo.
                No fue magia de un día para otro, fue un proceso de amor propio
                y constancia.
              </p>
            </div>

            <blockquote className="mt-10 p-6 border-l-2 border-brand-gold bg-brand-cream/50 rounded-r-xl relative overflow-hidden" data-id="element-137" data-mp="1wux3asvqnxl1">
              <div className="absolute top-0 right-0 w-16 h-16 bg-brand-gold/10 rounded-full blur-xl" data-id="element-138" data-mp="21urr2nk7w71v" />
              <p className="font-serif md:text-2xl text-brand-charcoal italic text-[14px] relative z-10" data-id="element-139" data-mp="1nvabmysta656">
                "No busco piel perfecta. Busco piel real, sana y libre." ❤️‍🩹
              </p>
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>;
}